import $api from "../../../../../services/axiosService";

export const requestUnepPhoneChangeThunkAction = (issueId, props) => async () => {
    try {
        props.setButtonLoading(true);
        await $api.post(`v1/c/certificates/issues/${issueId}/phone-change`);
        props.setButtonLoading(false);
        props.setShowPhoneVerify(true);
    } catch (e) {
        props.setButtonLoading(false);
        props.setBannerError(
            e?.response?.data?.detail || "Не удалось запросить смену номера. Попробуйте ещё раз.",
        );
    }
};